import { extractNationalNumber } from 'utils';

export const getCreatePasswordParams = (values: any) => ({
  ...(values.email ? { email: values.email?.trim() } : {}),
  ...(extractNationalNumber(values.mobilePhoneNumber) ? { phoneNumber: values.mobilePhoneNumber } : {}),
  inviteMethod: values.inviteMethod,
  isFromWorkerOnBoardingApp: true,
  activateWorker: true,
  languageCode: values?.languageCode,
  password: values.password,
  isSelfRegistered: values.isSelfRegistered,
});
